import React from "react";
import { AuthConsumer } from "./AuthProvider";
import {Spin} from "antd";
import ManyosSpinner from "../ManyosSpinner/ManyosSpinner";
export const SilentRenew = () => (
    <AuthConsumer>
        {({ signinSilentCallback }) => {
            signinSilentCallback();
            return <ManyosSpinner/>;
        }}
    </AuthConsumer>
);
